module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-100.758413b4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-100.png
// module id = 3297
// module chunks = 11